import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-app_icon-14",
  "use": "icon-app_icon-14-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-app_icon-14\"><g><path d=\"M35 10.93V27a4 4 0 01-4 4H5a4 4 0 01-4-4V10.93c0-.379.053-.746.152-1.094l15.482 11.82a2 2 0 002.416.008L34.834 9.788A4 4 0 0135 10.93z\" /><path d=\"M16.776 18.21L3.314 7.79A1 1 0 013.926 6h28.148a1 1 0 01.612 1.79L19.224 18.21a2 2 0 01-2.448 0z\" fill-opacity=\".6\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol